// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// CODE GRAPH EDGE SCHEMA
/////////////////////////////////////////

export const CodeGraphEdgeSchema = z.object({
  id: z.string(),
  source: z.string(),
  target: z.string(),
  type: z.string(),
  label: z.string().nullable(),
})

export type CodeGraphEdge = z.infer<typeof CodeGraphEdgeSchema>

export default CodeGraphEdgeSchema;
